// Request only the fields the app uses to avoid API rejecting large requests
export const API_URL =
  "https://restcountries.com/v3.1/all?fields=name,flags,capital,continents,population";
export const TIMEOUT_SEC = 10;
export const NUMBER_OF_RANDOM_NUMBERS = 4;
export const MATCHING_LIMITS = 2;
